import { LIGHTER_THEMES } from "./constants";
import { Theme } from "./types";

export const isLightTheme = (theme?: Theme) => {
  if (!theme) {
    return false;
  }

  const lighterTheme = Object.values(LIGHTER_THEMES).find(
    (lighterTheme) => lighterTheme === theme
  );

  return !!lighterTheme;
};

export const isDarkTheme = (theme?: Theme) => {
  return !isLightTheme(theme);
};
